import { createAsyncThunk } from "@reduxjs/toolkit";
import { MarathonsAPI } from "api/api/marathonsApi/marathonsApi";
import { GetMarathonAdminByIdParams, GetMarathonAdminByIdResponse } from "api/api/marathonsApi/types";

export const getMarathonAdminById = createAsyncThunk<
  GetMarathonAdminByIdResponse,
  GetMarathonAdminByIdParams
>(
  "marathons/getMarathonAdminById",
  async ({ marathonId }, { rejectWithValue }) => {
    try {
      const data = await MarathonsAPI.getMarathonAdminById({ marathonId });
      return data;
    } catch (error: any) {
      console.error("Error while getting marathon details", error);
      return rejectWithValue(error.response?.data || "Unknown error");
    }
  })